import { graphql } from "@opensea/graphql"

export const ChainBadgeFragment = graphql(`
  fragment ChainBadge on Chain {
    identifier
    name
  }
`)
